import Packery from 'packery';

export default function Bricks(handle, {
    gridHandle,
    itemHandle,
}) {
    const grid = handle.querySelector(gridHandle);

    const pckry = new Packery(grid, {
        itemSelector: itemHandle,
        percentPosition: true
    });

    setTimeout(() => {
        pckry.layout();
    }, "500");
}
